import React from "react";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import {
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  BlockDes,
} from "../Component";
import TeleconsultationAdminFlowNav from "./TeleconsultationAdminFlowNav";

const TeleconsultationPageShell = ({ headTitle, title, description, aside, children, contentStyle }) => {
  return (
    <Content>
      <div style={contentStyle}>
      <Head title={headTitle} />
      <BlockHead size="sm">
        <BlockBetween className="g-2 flex-wrap align-items-start">
          <BlockHeadContent className="min-w-0">
            <BlockTitle tag="h3" page>
              {title}
            </BlockTitle>
            {description != null && description !== false ? (
              typeof description === "string" ? (
                <BlockDes className="text-soft">{description}</BlockDes>
              ) : (
                description
              )
            ) : null}
          </BlockHeadContent>
          {aside ? (
            <BlockHeadContent className="ms-auto d-flex flex-wrap align-items-center flex-g-2 flex-shrink-0">
              {aside}
            </BlockHeadContent>
          ) : null}
        </BlockBetween>
      </BlockHead>
      <TeleconsultationAdminFlowNav />
      {children}
      </div>
    </Content>
  );
};

export default TeleconsultationPageShell;
